<template>
  <div>
    <div v-if="zone>0 && hrConnected==0" class="zone flex justify-content-center flex-vertical"
      :class="zoneRange">
      <span v-if="zoneRange == 'high'" :class="zoneRange" class="h2">Heart Rate too high</span> 
      <span v-else-if="zoneRange == 'low'" :class="zoneRange" class="h2">Heart Rate too low</span> 
    </div>
    <div v-else class="zone"></div>
    <div v-if="hrConnected == 0 && heartRate > user.maxHR" class="flex justify-content-center flex-vertical">
      <span class="max-hr h2">WARNING: Max HR Exceeded</span> 
    </div>
  </div>
</template>

<script>
  export default {
    name: 'zoneNotification',
    
    props: {
      zone: Number, 
      user:Object, 
      hrConnected:Number,
      heartRate:Number,
      heartRateZone:Number,
    },
    data() {
      return {
      }
    },
    methods: {
    },
    computed: {
      zoneRange() {
        if (this.heartRateZone < this.zone) 
          return "low";
        else if (this.heartRateZone > this.zone)
          return "high";
        else return "";
      }
    },
    watch: {
    },
    mounted() {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .zone {
    color:black;
    text-align:center;
    padding-top:1vw;
    padding-bottom:1vw;
  }

  .h3 {
    margin-top:0vw;
  }

  .low {
    background-color: rgb(80, 221, 249);
  }

  .high {
    background-color: rgb(250, 167, 167);
  }

  .range {
    background-color: rgb(179, 251, 179);
  }

  .max-hr {
    background-color:red;
    color:white;
  }
</style>
